module.exports = __webpack_public_path__ + "static/media/amigoo_check.b3a99ab2.svg";